import { render, staticRenderFns } from "./CallDetail.vue?vue&type=template&id=1f8697f3&"
import script from "./CallDetail.vue?vue&type=script&lang=ts&"
export * from "./CallDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports